'use client';

import builder, { BuilderComponent } from '@builder.io/react';

import RegisterComponents from 'components/Builder/RegisterComponents';

import type { FC } from 'react';

// The Builder component requires the public API key to be exposed on the client side.
// This is safe because it is a public key, meaning the value is not secret and poses no security risk.
// Note: Never use `NEXT_PUBLIC` for secret keys or sensitive data.
const BUILDER_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY || '';

builder.init(BUILDER_API_KEY);

interface BuilderPageProps {
  content?: any;
  model?: string;
}

const RenderBuilderContent: FC<BuilderPageProps> = ({ content, model = 'page', ...props }) => (
  <RegisterComponents>
    <BuilderComponent content={content} model={model} {...props} />
  </RegisterComponents>
);

export default RenderBuilderContent;
